import axios from 'axios';
import globals from "../config/appconfig";
import Utils from "../utils/Utils";

export default class FeedbackService {

    static urlFeedback = globals["app-url-backend-assistenti"] +"/feedback"

    static getAllFeedback(params) {
        return axios.get(this.urlFeedback + Utils.addQueryParamsToRequestUrl(params))
    }

    static salvaFeedback(json) {
        return axios.post(this.urlFeedback,json)
    }

    static modificaStatoFeedback(id, params) {
        return axios.put(this.urlFeedback+ "/"+id + Utils.addQueryParamsToRequestUrl(params))
    }

    static eliminaFeedback(id) {
        return axios.delete(this.urlFeedback+ "/"+id)
    }

}